import { Avatar, HStack, Stack, Text, Button, Box, Link } from '@chakra-ui/react'
import { Card, Image } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { getDateFormatLocale } from 'utils/getDateFormatLocale'
import { useTranslation } from 'react-i18next'
import { normalizeUrl } from 'utils/normalizeUrl'

const ArticleCard = ({ article }: { article: Article }) => {
  const [imgSrc, setImgSrc] = useState(article.image ?? '')
  const { t } = useTranslation()
  return (
    <Link
      href={`/articles/${normalizeUrl(article.title ?? '', article.id)}`}
      target="_blank"
      fontSize="sm"
      fontWeight="normal"
      display="block"
      _hover={{ textDecoration: 'none' }}
    >
      <Card.Root maxW="full" overflow="hidden">
        <Image
          src={imgSrc}
          alt={article.title ?? ''}
          maxH="300px"
          onError={() => setImgSrc('https://leid.no/cdn/articles/previews/Leid.no_on_Trustpilot__1_.png')}
          objectFit="cover"
        />
        <Card.Body gap="2">
          <HStack mb="6" gap="3">
            <Avatar.Root>
              <Avatar.Fallback name={article.fullName} />
            </Avatar.Root>
            <Stack gap="0">
              <Text fontWeight="semibold" textStyle="sm" lineHeight="normal">
                {article.fullName}
              </Text>
              <Text color="fg.muted" textStyle="sm" lineHeight="normal">
                {format(new Date(article.updatedAt || ''), 'dd.MM.yyyy', {
                  locale: getDateFormatLocale(),
                })}
              </Text>
            </Stack>
          </HStack>
          <Card.Title lineClamp={1} lineHeight="normal">
            {article.title}
          </Card.Title>
          <Card.Description lineClamp={2} lineHeight="normal">
            {article.summary}
          </Card.Description>
        </Card.Body>
        <Card.Footer gap="2">
          <Box
            borderBottomRadius="sm"
            paddingTop={6}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            borderTop="1px solid {colors.green.a50}"
          >
            <Text fontSize="sm" marginRight={2} lineHeight="normal">
              {t('readMore')}
            </Text>
            <Button
              variant="ghost"
              background="updatedLeid.peach"
              borderRadius="full"
              padding={2}
              color="black"
              transition="all 0.3s ease-in-out"
              _hover={{ background: 'black', color: 'updatedLeid.peach' }}
            >
              <FaArrowRight size={16} />
            </Button>
          </Box>
        </Card.Footer>
      </Card.Root>
    </Link>
  )
}

export default ArticleCard
